function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  && {\n    display: flex;\n    flex-wrap: wrap;\n\n    > * {\n      margin-right: ", ";\n      margin-bottom: ", ";\n\n      /* width and margin of component in different medias. */\n      ", "\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { Flex } from '../../index';
import fillArray from '../Util/fillArray';

var createCss = function createCss(cols, columnSpacing) {
  return "\n    width: " + ("calc((100% - (" + columnSpacing + " * " + (cols - 1) + ")) / " + cols + ")") + ";\n    &:nth-child(n) {\n      margin-right: " + columnSpacing + ";\n    }\n\n    &:nth-child(" + (cols + 'n') + ") {\n      margin-right: 0;\n    }\n\n    &:nth-last-child(-n + " + cols + ") {\n      margin-bottom: 0;\n    }\n  ";
};

var media = function media(columns, columnSpacing, theme) {
  var css = theme.breakpoints.reduce(function (acc, currValue, index) {
    return acc + ("@media (min-width: " + theme.breakpoints[index] + ") {\n          " + createCss(columns[index + 1], columnSpacing) + ";\n        }\n      ");
  }, createCss(columns[0], columnSpacing));
  return css;
};

var HorizontalList = styled(function (_ref) {
  var columns = _ref.columns,
      columnSpacing = _ref.columnSpacing,
      rowSpacing = _ref.rowSpacing,
      theme = _ref.theme,
      props = _objectWithoutPropertiesLoose(_ref, ["columns", "columnSpacing", "rowSpacing", "theme"]);

  return /*#__PURE__*/React.createElement(Flex, props);
}).attrs(function (props) {
  var array = !Array.isArray(props.columns) ? [props.columns] : props.columns;
  return {
    columns: fillArray(array, props.theme.breakpoints.length + 1, array[array.length - 1])
  };
})(_templateObject(), function (props) {
  return props.columnSpacing;
}, function (props) {
  return props.rowSpacing;
}, function (props) {
  return media(props.columns, props.columnSpacing, props.theme);
});
HorizontalList.propTypes = {
  columns: PropTypes.oneOfType([PropTypes.number, PropTypes.array]),
  columnSpacing: PropTypes.string,
  rowSpacing: PropTypes.string
};
HorizontalList.defaultProps = {
  columns: [1],
  columnSpacing: '32px',
  rowSpacing: '24px'
};
export { HorizontalList };
export default withTheme(HorizontalList);